export default __webpack_public_path__ + "static/media/tratorMobile.a03c5dd8.png";